import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import Loader from "../feature-module/loader/loader";

// Check if the user is intentionally logging out
const isLogoutAction = () => {
  // Check if this is a logout action by checking the flag
  const isLogout = localStorage.getItem("isLoggingOut") === "true";
  return isLogout;
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth || {});
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [showedWarning, setShowedWarning] = useState(false);

  useEffect(() => {
    const restoreAuthSimulation = setTimeout(() => {
      setLoading(false);
    }, 10);

    return () => clearTimeout(restoreAuthSimulation);
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    // Skip warning if:
    // 1. User is intentionally logging out
    // 2. User is accessing the signin page directly
    // 3. User is at the root URL (which redirects to signin)
    const isSigninPage = location.pathname === "/signin";
    const isRootPage = location.pathname === "/";
    const loggingOut = isLogoutAction();

    if (!showedWarning && !isSigninPage && !isRootPage && !loggingOut) {
      setShowedWarning(true);
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You need to sign in to access this page.",
        showConfirmButton: false,
        timer: 2000,
      });
    }

    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
